export const SURVEY_CLOSED = true;

export const SURVEY_QUESTIONS = [
  {
    id: "q1_awareness",
    type: "single",
    emoji: "\u{1F44B}",
    question: "Do you know what Artificial Intelligence (AI) is?",
    options: [
      "Yes — I know what it is and have a good idea of how it works",
      "I've heard of it, but I'm not really sure what it means",
      "Not really — I'm here to learn"
    ],
    scored: true,
    required: true
  },
  {
    id: "q1b_self_rating",
    type: "single",
    emoji: "\u{1F4CA}",
    question: "How would you rate your current AI knowledge?",
    helper: "Just your honest self-assessment.",
    options: [
      "Very low — I'm just getting started",
      "Low — I know a little bit",
      "Average — I understand the basics",
      "Good — I'm fairly confident",
      "Very good — I know my way around AI quite well"
    ],
    scored: true,
    required: true
  },
  {
    id: "q2_ai_beyond_llm",
    type: "multi",
    emoji: "\u{1F4F1}",
    question: "Select which of these apps you know use AI technology.",
    helper: "Select all that apply.",
    options: [
      "Google Maps",
      "Spotify / Youtube Music",
      "Your phone camera",
      "E-commerce shopee",
            "Copilot / ChatGPT / Claude / Gemini",
      "Gmail",
      "Google search",
      "None of the above",
      "Sorry, I'm not sure"
    ],
    exclusive: ["None of the above", "Sorry, I'm not sure"],
    scored: true,
    required: true
  },
  {
    id: "q3_tools_known",
    type: "multi",
    emoji: "\u{1F9E0}",
    question: "Which of these AI tools have you heard of?",
    helper: "Select all that you recognise, even if you haven't used them.",
    options: [
      "ChatGPT",
      "Gemini",
      "Copilot",
      "Claude",
      "Perplexity",
      "None of these sound familiar to me"
    ],
    exclusive: ["None of these sound familiar to me"],
    scored: true,
    required: true
  },
  {
    id: "q4_usage",
    type: "single",
    emoji: "\u{1F680}",
    question: "Are you currently using any AI tools?",
    helper: "For example, ChatGPT, Copilot, or Gemini.",
    options: [
      "Yes, regularly",
      "Yes, occasionally",
      "I tried once or twice",
      "No, never"
    ],
    scored: true,
    required: true
  },
  {
    id: "q6_context",
    type: "single",
    emoji: "\u{1F3AF}",
    question: "Do you use AI mainly for work, personal use, or both?",
    helperNote: "Shown because you indicated you use AI.",
    options: [
      "Mostly for work",
      "Mostly for personal life",
      "Both equally",
      "It depends / not sure"
    ],
    dependsOn: { id: "q4_usage", values: ["Yes, regularly", "Yes, occasionally"] },
    scored: false,
    required: true
  },
  {
    id: "q_tool_most_used",
    type: "single",
    emoji: "\u2B50",
    question: "Which AI tool do you use most?",
    helperNote: "Shown because you indicated you use AI.",
    options: [
      "ChatGPT",
      "Microsoft Copilot",
      "Claude",
      "Gemini",
      "Perplexity",
      "Others"
    ],
    hasOtherField: true,
    dependsOn: { id: "q4_usage", values: ["Yes, regularly", "Yes, occasionally"] },
    scored: false,
    required: true
  },
  {
    id: "q_paying",
    type: "single",
    emoji: "\u{1F4B3}",
    question: "Are you paying for any AI tools today?",
    helperNote: "Shown because you indicated you use AI.",
    options: ["Yes", "No", "My workplace is paying for me"],
    dependsOn: { id: "q4_usage", values: ["Yes, regularly", "Yes, occasionally"] },
    scored: false,
    required: true
  },
  {
    id: "q6_use_cases",
    type: "multi",
    emoji: "\u{1F6E0}\uFE0F",
    question: "What do you use AI for?",
    helper: "Select all that apply.",
    helperNote: "Shown because you indicated you use AI.",
    options: [
      "Writing emails, reports, or content",
      "Research and finding information",
      "Summarizing documents",
      "Brainstorming ideas",
      "Translation",
      "Automating work",
      "Data analysis",
      "Creating images or visuals",
      "Personal tasks like planning / travel / recipes"
    ],
    dependsOn: { id: "q4_usage", values: ["Yes, regularly", "Yes, occasionally"] },
    scored: true,
    required: true
  },
  {
    id: "q5_frequency",
    type: "single",
    emoji: "\u{1F4C5}",
    question: "How often do you use AI tools?",
    helperNote: "Shown because you indicated you use AI.",
    options: [
      "Daily",
      "A few times a week",
      "A few times a month"
    ],
    dependsOn: { id: "q4_usage", values: ["Yes, regularly", "Yes, occasionally"] },
    scored: true,
    required: true
  },
  {
    id: "q7_barriers_light",
    type: "multi",
    emoji: "\u{1F914}",
    question: "Are there any concerns or barriers that stop you from using AI more?",
    helper: "Select all that apply.",
    helperNote: "Shown because you indicated you use AI.",
    options: [
      "Not sure what else I can use it for",
      "Worried about accuracy",
      "Privacy concerns",
      "Cost",
      "Workplace has not encouraged or approved it",
      "No time to explore more",
      "Nothing really"
    ],
    dependsOn: { id: "q4_usage", values: ["Yes, regularly", "Yes, occasionally"] },
    scored: false,
    required: true
  },
  {
    id: "q7_barriers_full",
    type: "multi",
    emoji: "\u{1F331}",
    question: "What has stopped you from using AI so far?",
    helper: "Select all that apply.",
    helperNote: "Shown because you haven't started using AI regularly yet.",
    options: [
      "I don't know how to start",
      "I'm not sure what it can do for me",
      "I don't trust the accuracy",
      "Privacy or data security concerns",
      "No time to learn",
      "My company hasn't said it's okay",
      "I tried it and it wasn't useful",
      "Worried it might affect jobs"
    ],
    dependsOn: { id: "q4_usage", values: ["I tried once or twice", "No, never"] },
    scored: false,
    required: true
  },
  {
    id: "q8_concerns",
    type: "multi",
    emoji: "\u{1F4AD}",
    question: "Which of these concerns about AI apply to you?",
    helper: "Select all that apply.",
    options: [
      "Job security",
      "Fake news or misinformation",
      "Privacy of personal data",
      "AI giving wrong answers",
      "Bias and unfairness",
      "AI becoming too powerful",
      "It feels like it is only for tech-savvy people",
      "There are no clear rules or guidelines",
      "No concerns at all"
    ],
    exclusive: ["No concerns at all"],
    scored: false,
    required: true
  },
  {
    id: "q8b_concerns_open",
    type: "text",
    emoji: "\u{1F4AC}",
    question: "Do you have any other concerns about AI that weren't listed in the previous question?",
    helper: "Optional — feel free to skip.",
    optional: true,
    scored: false,
    required: false
  },
  {
    id: "q9_knowledge",
    type: "multi",
    emoji: "\u{1F4A1}",
    question: "Select the actions you know AI can perform today.",
    helper: "Some of these are true and some are not. Select what you know is correct.",
    options: [
      "Write emails, summaries, and reports",
      "Translate languages",
      "Generate images from text",
      "Help analyze data and spot trends",
      "Help write and fix code",
      "Hold natural, useful conversations",
      "Genuinely feel emotions and have opinions",
      "Always give 100% correct answers",
      "Predict the future"
    ],
    scored: true,
    required: true
  },
  {
    id: "q10_context",
    type: "single",
    emoji: "\u2728",
    question: "If you were to use AI more, which area of your life would benefit most?",
    options: ["Work", "Personal life", "Both equally", "Not sure yet"],
    scored: false,
    required: true
  },
  {
    id: "q11_learn",
    type: "multi",
    emoji: "\u{1F4DA}",
    question: "What are the top 3 things you wish to learn about AI today?",
    helper: "Choose up to 3.",
    maxSelections: 3,
    options: [
      "AI basics and how it works",
      "How to use tools like ChatGPT well",
      "How to write better prompts",
      "How AI can help in my specific role",
      "Risks, limits, and how to check outputs",
      "Responsible and ethical use",
      "Future trends",
      "How AI is different from normal software"
    ],
    scored: false,
    required: true
  },
  {
    id: "q11b_learn_open",
    type: "text",
    emoji: "\u{1F50D}",
    question: "Is there anything else you'd like to learn about AI?",
    helper: "Optional — feel free to skip.",
    optional: true,
    scored: false,
    required: false
  },
  {
    id: "q13_hopes",
    type: "text",
    emoji: "\u{1F31F}",
    question: "What's one thing you hope AI can help you do better or faster?",
    helper: "Optional — feel free to skip.",
    optional: true,
    scored: false,
    required: false
  },
  {
    id: "q14_questions",
    type: "text",
    emoji: "\u{1F4DD}",
    question: "Anything you want us to note on regarding AI usage at AMP?",
    helper: "Optional — this is the last question.",
    optional: true,
    scored: false,
    required: false
  }
];

export const PERSONA_DEFINITIONS = {
  "The Explorer": {
    emoji: "\u{1F331}",
    description: "New to AI, with little exposure so far. Likely needs fundamentals, reassurance, and simple practical examples.",
    color: "#22c55e",
    vibe: "Just getting started — and that's perfectly okay!"
  },
  "The Curious One": {
    emoji: "\u{1F50D}",
    description: "Aware of AI and interested, but not yet using it confidently or consistently. Likely needs confidence, examples, and clarity.",
    color: "#f59e0b",
    vibe: "Interested and ready to explore more!"
  },
  "The Everyday User": {
    emoji: "\u26A1",
    description: "Already using AI in some practical ways. Likely ready to improve prompting, quality checking, and broader use cases.",
    color: "#a21caf",
    vibe: "Already in the game — time to level up!"
  },
  "The AI Champion": {
    emoji: "\u{1F680}",
    description: "High familiarity and active usage. Likely ready for advanced use, governance, peer support, and experimentation.",
    color: "#3b82f6",
    vibe: "Leading the way with AI!"
  }
};

export function getVisibleQuestions(answers) {
  return SURVEY_QUESTIONS.filter(q => {
    if (!q.dependsOn) return true;
    const depValue = answers[q.dependsOn.id];
    return q.dependsOn.values.includes(depValue);
  });
}
